<template>
  <div class='massLoss-list'>
    <div class='tabs'>
      <div @click='typeFun(1)' class='left' :class='{ active: searchForm.type === 1 }'>收入台账与开票</div>
      <div @click='typeFun(2)'  class='right' :class='{ active: searchForm.type === 2 }'>支出台账与开票</div>
    </div>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1' ref='searchForm'>
        <el-form-item label='板块：'>
          <!-- <el-input v-model='searchForm.plate' size='mini' placeholder='请输入板块'></el-input> -->
          <el-select v-model="searchForm.plate" size="mini" filterable placeholder="请选择板块" value-key="id">
            <el-option v-for="item in plateOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label='台账月：'>
          <el-input v-model='searchForm.standingBookMonth' size='mini'
                    placeholder='请输入台账月'></el-input>
        </el-form-item>
        <el-form-item label='委托商：'>
          <el-input v-model='searchForm.consignorName' size='mini'
                    placeholder='请输入委托商名称'></el-input>
        </el-form-item>
        <el-form-item label='发票号：'>
          <el-input v-model='searchForm.invoiceNo' size='mini' placeholder='请输入发票号'></el-input>
        </el-form-item>
        <el-form-item label='对账编号：'>
          <el-input v-model='searchForm.settNo' size='mini' placeholder='请输入对账编号'></el-input>
        </el-form-item>
       <el-form-item label='结算方式：'>
         <el-select v-model="searchForm.settType" size="mini" filterable placeholder="请选择结算方式" value-key="id">
           <el-option v-for="item in settTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
         </el-select>
       </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' class='resetBtn' @click='refreshBtn'>刷新</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          :summary-method="getSumRol"
          :span-method="arraySpanMethod"
          :show-summary="true"
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='plate' label='板块' align='center' min-width='100px'  :formatter="getPlate"/>
          <el-table-column prop='consignorName' label='委托商' align='center' min-width='140px' v-if="this.searchForm.type === 1" show-overflow-tooltip/>
          <el-table-column prop='supplierName' label='供应商' align='center' min-width='140px' v-else show-overflow-tooltip/>
          <el-table-column label='台账统计' align='center' min-width='100px'>
            <el-table-column prop='ledgerNumber' label='台账编号' align='center' min-width='100px' />
            <el-table-column prop='standingBookMonth' label='台账月' align='center' min-width='100px' />
            <el-table-column prop='ledgerNum' label='台账数量' align='center' min-width='100px' />
            <el-table-column prop='ledgerPrice' label='台账金额' align='center' min-width='100px' />
          </el-table-column>
          <el-table-column label='开票统计' align='center' min-width='100px'>
            <el-table-column prop='settNo' label='对账编号' align='center' min-width='100px' />
            <el-table-column prop='settType' label='结算方式' align='center' min-width='100px' :formatter="settTypeFormat"/>
            <el-table-column prop='invoiceNum' label='开票数量' align='center' min-width='100px' />
            <el-table-column prop='invoicePrice' label='开票金额' align='center' min-width='100px' />
            <el-table-column prop='invoiceNo' label='发票号' align='center' min-width='100px' />
            <el-table-column prop='invoiceTime' label='开票日期' align='center' min-width='100px' />
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { autoFlashData, autoFlashData1, getLedgerPageList } from '@/service/getData';
import { deleteEmployee } from '@/service/audit';

export default {
  data(){
    return{
      searchForm: {
        type: 1,
        plate: '',
        standingBookMonth: '',
        consignorName: '',
        invoiceNo: '',
        settNo: '',
        settType: '',
        page: 1,
        rows: 10,
      },
      plateOptions: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '运输',
          value: '1',
        },
        {
          label: '港口库房',
          value: '2',
        },
        {
          label: '其他',
          value: '3',
        },
      ],
      settTypeOptions: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '合同价',
          value: '1',
        },
        {
          label: '预结算价',
          value: '2',
        },
      ],
      tableLoading: false,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      total: 0,
    }
  },
  mounted() {
    this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
  },
  methods:{
    exportData() {
      window.exportExcelAll('get', '/ledger/invoice/exportExcel', {
        ...this.searchForm
      });
    },
    //收入台账与开票/支出台账与开票切换
    typeFun(val) {
      this.searchForm.type = val;
      this.$nextTick(() => {
        this.total = 0;
        this.searchForm.plate = ''
        this.searchForm.standingBookMonth = ''
        this.searchForm.consignorName = ''
        this.searchForm.invoiceNo = ''
        this.searchForm.settNo = ''
        this.searchForm.settType = ''
      })
      // this.searchBtn()
    },
    settTypeFormat(r, c, cellValue) {
      switch (cellValue) {
        case 1:
          return '合同价';
        case 2:
          return '预结算价';
      }
    },
    getPlate(r, c, cellValue) {
      switch (cellValue) {
        case 1:
          return '运输';
        case 2:
          return '港口库房';
        case 3:
          return '其他费用';
      }
    },
    //查询
    searchBtn(){
      this.searchForm.page = 1
      this.getTableData()
    },
    //获取表格数据
   async getTableData(){
      this.tableLoading = true
      const res = await getLedgerPageList(this.searchForm)
     this.tableLoading = false
     if(res.status !== 0) return this.$message.error(res.message)
     this.tableData = res.data.records
     this.total = res.data.total
    },
    //重置
    resetBtn(){
      this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
    },
    //刷新
    refreshBtn(){
      this.$confirm('是否刷新前六个月数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = this.searchForm.type === 1 ? await autoFlashData() :
            this.searchForm.type === 2 ? await autoFlashData1() : null
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this.getTableData();
        })
        .catch(() => false);
    },
    //表尾合计行计算方法
    getSumRol(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        //相同consignorName和ledgerNumber去重
        const dataList = data.reduce((acc, cur) => {
          const array = acc.find((item) => item.consignorName === cur.consignorName && item.ledgerNumber === cur.ledgerNumber);
          if (!array) {
            acc.push(cur);
          }
          return acc;
        }, []);
        const values = dataList.map(item => Number(item[column.property]));
        if (column.property === 'ledgerNum' || column.property ==='ledgerPrice' || column.property==='invoiceNum' || column.property==='invoicePrice' ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ''
        }
      });
      return sums
    },

    //根据台账编号合并台账数量、台账金额
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 初始化合并数组
      let spanOneArr = [];
      let concatOne = 0;

      // 计算每一行的合并情况
      this.tableData.map((item, index) => {
        if (index === 0) {
          spanOneArr.push(1); // 第一行默认为1
        } else {
          // 判断是否与上一行的委托商和台账编号相同
          if (item.consignorName === this.tableData[index - 1].consignorName
            && item.ledgerNumber === this.tableData[index - 1].ledgerNumber) {
            spanOneArr[concatOne] += 1; // 增加合并行数
            spanOneArr.push(0); // 当前行标记为0，表示被合并
          } else {
            spanOneArr.push(1); // 新的一组，重置为1
            concatOne = index; // 更新起始索引
          }
        }
      });

      // 判断当前列是否需要合并
      if ([4, 5].includes(columnIndex)) { // 合并需要合并的列
        const _row = spanOneArr[rowIndex]; // 获取当前行的合并行数
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row, // 设置合并行数
          colspan: _col // 设置合并列数
        };
      }
    },
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    },
  }
}
</script>


<style scoped lang="scss">
.massLoss-list{
  width: 100%;
  padding: 20px 15px 0 25px;
  display: flex;
  flex-direction: column;
.tabs {
  float: left;
  margin-left: 20px;
  margin-top: 2px;
  display: flex;
  justify-content: space-between;
  width: 239px;
  margin-bottom: 20px;

  div {
    //background: #ccc;
    width: 120px;
    height: 30px;
    line-height: 30px;
    color: #48599E;
    text-align: center;
    font-size: 13px;
    cursor: pointer;
    border: 1px solid #48599E;
    font-weight: 700;
    transition: all .3s;
  }

  .left {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .right {
    /*width: 160px;*/
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .active {
    background: #48599E;
    color: #fff;
  }
}
}
</style>
